module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/brag/brag-03-7bf45f200cbc51f831a05e9bdefeac7e.jpg";